import { HttpContextToken } from '@angular/common/http';

/**
 * Cabeçalho só de front: o `LoaderInterceptor` lê, trata 401 sem logout e **remove** antes do fetch.
 * Evita depender só de `HttpContextToken` (em builds com chunks duplicados, o token no service e no
 * interceptor pode ser instâncias diferentes e o contexto deixa de bater).
 */
export const SKIP_LOGOUT_ON_401_HEADER = 'X-Ratoeira-Skip-Logout-On-401';
export const SKIP_LOGOUT_ON_401_HEADER_VALUE = '1';

/**
 * Quando true, um 401 nesta requisição não dispara `AuthService.logout()` no LoaderInterceptor.
 * Use em chamadas onde 401 pode refletir permissão/recurso específico (ex.: stats VTurb por player),
 * não necessariamente sessão Raads inválida.
 */
export const SKIP_LOGOUT_ON_401 = new HttpContextToken<boolean>(() => false);
